import { render, staticRenderFns } from "./DropFileArea.vue?vue&type=template&id=74ea0166&scoped=true&"
import script from "./DropFileArea.vue?vue&type=script&lang=js&"
export * from "./DropFileArea.vue?vue&type=script&lang=js&"
import style0 from "./DropFileArea.vue?vue&type=style&index=0&id=74ea0166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea0166",
  null
  
)

export default component.exports